import { List, Datagrid, TextField, EditButton, 
    Edit, SimpleForm, TextInput, Create, SearchInput, 
    DateInput, DateField, Show, SimpleShowLayout, ShowButton, 
    FileField, BooleanInput, FunctionField, 
    DateTimeInput} from "react-admin";
import { IsActiveIcon } from "../Consts";

const softwareFilters = [
    <SearchInput source="q" alwaysOn />,
    <TextInput label="Platform" source="platform" />,
    <TextInput label="Description" source="description" />,
];

// detect using: ListGuesser
export const SoftwareList = (props: any) => (
    <List {...props} filters={softwareFilters} >
        <Datagrid>
            <TextField label="Id" source="id" />
            <TextField source="platform" />
            <TextField source="versionCode" />
            <TextField source="versionName" />
            <TextField source="releaseTime" />
            <TextField source="fileName" />
            <FunctionField
                label="Active?"
                render={(record: any) => <IsActiveIcon isActive={record.isActive} />}
            />
            <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

// detect using: EditGuesser
// bug because BooleanInput expects true/false, 1/0 is used currently!
const titleStyle = { width: '350px' };

export const SoftwareEdit = () => (
    <Edit>
        <SimpleForm>
            <TextInput label="Id" disabled source="id" />
            <TextInput source="platform" />
            <TextInput source="versionCode" />
            <TextInput source="versionName" />
            <TextInput source="description" multiline style = {titleStyle} />
            <DateTimeInput source="releaseTime" />
            <TextInput source="fileName" />
            <TextInput source="md5" />
            <BooleanInput source="isActive" />
        </SimpleForm>
    </Edit>
);

export const SoftwareCreate = (props: any) => (
    <Create {...props} redirect="list">
        <SimpleForm>
            <TextInput source="platform" />
            <TextInput source="versionCode" />
            <TextInput source="versionName" />
            <TextInput source="description" multiline style = {titleStyle} />
            <DateTimeInput source="releaseTime" />
            <TextInput source="fileName" />
            <TextInput source="md5" />
            <BooleanInput source="isActive" />
        </SimpleForm>
    </Create>
);

export const SoftwareShow = () => (
    <Show>
        <SimpleShowLayout>
            <TextField source="platform" />
            <TextField source="versionCode" />
            <TextField source="versionName" />
            <TextField source="description" component="pre" />
            <TextField source="releaseTime" />
            <FileField source="link.url" title="link.title" label="Install file" download="true" />
            <TextField source="md5" />
            <FunctionField
                label="Active?"
                render={(record: any) => <IsActiveIcon isActive={record.isActive} />}
            />
        </SimpleShowLayout>
    </Show>
);
